export const numericExtendedOperators = [
    { text: 'Is integer', operator: 'isinteger' },
    { text: 'Is fractional', operator: 'isfractional' },
];

export const isNumericExtendedOperator = (operator: string | Function) =>
    numericExtendedOperators.some(o => o.operator === operator);
